var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "day-legend item" }, [
    _c("img", { attrs: { src: require("@/assets/IC_Trabajo.svg") } }),
    _vm.withTitle
      ? _c("span", [_vm._v(" " + _vm._s(_vm.title) + " ")])
      : _vm._e(),
    _vm.badge
      ? _c("span", { staticClass: "badge badge-warning notify-badge" }, [
          _vm._v(_vm._s(_vm.badge)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }